import { Alert, Snackbar } from '@mui/material'
import React from 'react'

const Toast = ({
  show = false, duration = 5000, onClose, error = false, message, severity,
}) => {
  return (
    <Snackbar
      open={show}
      autoHideDuration={duration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert severity={severity || (error ? 'error' : 'success')} variant='filled'>{message}</Alert>
    </Snackbar>
  )
}

export default Toast
